import classnames from 'classnames'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import { User } from '../../../models/User'
import useRoutes from '../../../state/useRoutes'
import UserAvatar from '../../UserAvatar/UserAvatar'
import UserRoleIcon from '../../UserRoleIcon/UserRoleIcon'

import styles from './UserSlug.module.scss'

export default React.memo(function UserSlug({ user }: { user: User }) {
  const { t } = useTranslation()
  const routes = useRoutes()

  const Component = !user.isAnonymous ? Link : 'span'

  return (
    <Component
      to={routes.manageUser.url({ uuid: user.uuid })}
      className={classnames(styles.UserSlug, { skeleton: user.isDummy, [styles.inactive]: user.status !== 'active' })}
    >
      <UserAvatar className={styles.avatar} user={user} omitRoleIcon />
      <span>{user.isAnonymous ? t('user.anonymous') : `${user.firstname} ${user.lastname}`}</span>
      <UserRoleIcon userRole={user.role} userStatus={user.status} className={styles.userRoleIcon} />
    </Component>
  )
})
